<template>
    <div class="orderManagementClass">
        <div class="orderManagementContent" :style="contentViewHeight">
            <div class="printOrderListBox">
                <div>
                    <div class="orderSearchBox">
                        <div class="searchTop">
                            <div class="searchItem">
                                <div class="tel">企业名称</div>
                                <el-input v-model="enterpriseName" clearable placeholder="企业名称"></el-input>
                            </div>
                            <div class="searchItem">
                                <div class="name">用户名称</div>
                                <el-input v-model="userName" clearable placeholder="用户名称"></el-input>
                            </div>
                            <div class="searchItem">
                                <div class="tel">手机号</div>
                                <el-input v-model="userTel" clearable placeholder="手机号"></el-input>
                            </div>
                        </div>
                        <div class="searchBottom">
                            <div class="searchItem">
                                <div class="name">注册时间</div>
                                <el-date-picker
                                    v-model="createDateValue"
                                    value-format="yyyy-MM-dd"
                                    type="daterange"
                                    range-separator="至"
                                    start-placeholder="开始日期"
                                    end-placeholder="结束日期">
                                </el-date-picker>
                            </div>
                            <div class="searchItem">
                                <el-button class="searchBtn" @click="search">搜索</el-button>
                                <el-button type="text" class="resetBtn" @click="resetData">
                                    <i class="iconfont icon-qingchushujuku"></i>
                                    <span>清除条件</span>
                                </el-button>
                            </div>
                        </div>
                    </div>
                    <div class="orderListTable">
                        <el-table
                            :data="tableData"
                            border
                            style="width: 100%" class="tableContent">
                            <el-table-column
                                prop="enterpriseName"
                                label="企业名称"
                                header-align="center"
                                show-overflow-tooltip
                                align="center" width="200">
                            </el-table-column>
                            <el-table-column
                                prop="name"
                                label="用户名称"
                                header-align="center"
                                show-overflow-tooltip
                                align="center">
                            </el-table-column>
                            <el-table-column
                                prop="tel"
                                label="电话"
                                header-align="center"
                                align="center"
                                show-overflow-tooltip
                                width="200">
                            </el-table-column>
                            <el-table-column
                                prop="mail"
                                label="邮件"
                                header-align="center"
                                show-overflow-tooltip
                                align="center">
                            </el-table-column>
                            <el-table-column
                                prop="survivalCn"
                                align="center"
                                header-align="center"
                                label="状态" >
                            </el-table-column>
                            <el-table-column
                                prop="createdDate"
                                align="center"
                                header-align="center"
                                label="注册时间" width="200">
                            </el-table-column>
                            <el-table-column
                                label="操作"
                                header-align="center"
                                align="center"
                                width="230">
                                <template slot-scope="scope">
                                    <el-button type="text" size="small" v-if="scope.row.survival=='ENABLE'" @click="changeSurvival(scope.row.uuid,'DISABLE')">停用</el-button>
                                    <el-button type="text" size="small" v-if="scope.row.survival=='DISABLE'" @click="changeSurvival(scope.row.uuid,'ENABLE')">启用</el-button>
                                    <el-button type="text" size="small" @click="deleteUser(scope.row.uuid)">删除</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                        <el-pagination
                            background
                            @current-change="handleCurrentChange"
                            @prev-click="handleCurrentChange"
                            @next-click="handleCurrentChange"
                            layout="total,prev, pager, next,jumper"
                            :current-page="current"
                            :page-size="pageSize"
                            :total="total" class="pagination">
                        </el-pagination>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    import {getUserStaffListPage,restPassWord,moveUser,deleteUser} from  "../../utils/userManager";

    export default {
        components: {},
        data() {
            return {
                form: {},
                createDateValue: null,
                userName: '',
                userTel:'',
                enterpriseName:'',
                tableData: [
                ],
                current: 1,
                pageSize: 10,
                total: 0,
                dialogVisible: false,
                title: '',
                currentAudit: '',
                designer:{},
            }
        },
        computed: {
            contentViewHeight() {
                let height = document.documentElement.clientHeight - 120
                return {minHeight: height + 'px'}
            },
        },
        created() {
            this.search();
        },
        methods: {
            resetData(){
                this.createDateValue = null;
                this.userName = '';
                this.userTel = '';
                this.enterpriseName='';
                this.form.inputDate ='';
            },
            // 分页
            handleCurrentChange(val){
                this.current = val;
                this.search();
            },
            search(){
                this.form.name = this.userName;
                this.form.tel =  this.userTel;
                this.form.enterpriseName  = this.enterpriseName;
                if(this.createDateValue != null){
                    this.form.inputDate = this.createDateValue.join(" - ");
                }
                this.form.current = this.current;
                this.form.pageSize = this.pageSize;
                this.form.identity = "STAFF";
                getUserStaffListPage(this.form).then((res)=>{
                    this.tableData = res.list;
                    this.total = res.total;
                    this.pageSize = res.size;
                    this.current = res.current;
                });
            },
            changeSurvival(uuid,survival){
                let msg ="";
                if("DISABLE"==survival){
                    msg = "停用用户";
                }else {
                    msg = "启用用户";
                }
                this.$confirm('确定'+msg+'吗?', "警告", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                }).then(function() {
                    let param = {survival:survival};
                    return moveUser(uuid,param);
                }).then(() => {
                    this.$message.success(""+msg+"成功");
                    this.search();
                }).catch(function() {
                    this.$message.error(""+msg+"失败");
                });
            },
            deleteUser(uuid){
                this.$confirm('确定删除用户吗?', "警告", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                }).then(function() {
                    return deleteUser(uuid);
                }).then(() => {
                    this.$message.success("删除用户成功");
                    this.search();
                }).catch(function() {
                    this.$message.error("删除用户失败");
                });
            }
        }
    }
</script>

<style scoped lang="less">
    .orderManagementClass {
        position: relative;
        width: 100%;
        padding: 0 20px 20px;
        .orderManagementContent {
            background: #fff;
            .printOrderListBox {
                padding: 20px;
                .orderSearchBox {
                    margin-bottom: 20px;
                    .searchTop{
                        display: flex;
                        align-items: center;
                        margin-bottom: 22px;
                    }
                    .searchBottom{
                        display: flex;
                        align-items: center;
                        margin-bottom: 22px;
                    }
                    .searchItem{
                        display: flex;
                        align-items: center;
                        margin-right: 30px;
                        .name{
                            padding-right: 20px;
                            min-width: 100px;
                        }
                    }
                    /deep/ .el-input {
                        width: initial;
                    }

                    /deep/ .el-input__inner {
                        width: 242px;
                        height: 35px;
                        min-height: 35px;
                        font-size: 12px;
                        color: #999999;
                        background-color: #f2f4f7;
                        border: 1px solid #f2f4f7;
                        border-radius: 5px;

                        &:hover, &:focus {
                            background-color: #fff;
                            border: 1px solid #108EE9;
                        }
                    }
                    /deep/.el-range-editor{
                        width: 500px;
                        /deep/.el-range-input{
                            width: 242px;
                            height: 32px;
                            min-height: 32px;
                            font-size: 12px;
                            color: #999999;
                            background-color: #f2f4f7;
                        }
                        /deep/.el-range__icon,/deep/.el-range-separator,/deep/.el-range__close-icon{
                            line-height: 29px;
                        }
                        &:hover, &:focus {
                            background-color: #fff;
                            border: 1px solid #108EE9;
                            /deep/.el-range-input{
                                background-color: #fff;
                            }
                        }
                    }
                    /deep/ .el-input__prefix {
                        top: -3px;
                    }

                    /deep/ .el-input__suffix {
                        top: 2px;
                    }

                    /deep/ .el-button {
                        display: block;
                        line-height: 35px;
                        padding: 0;
                        height: 35px;
                    }

                    .searchBtn {
                        width: 82px;
                        background: #3d7fff;
                        border: none;
                        border-radius: 15px;
                        font-size: 14px;
                        color: #FFFFFF;
                    }

                    .resetBtn {
                        color: #333333;
                        &:hover{
                            color: #3d7fff;
                        }
                    }
                }

                .tableContent {
                    min-height: 600px;

                    /deep/ .el-table__header {
                        tr {
                            th {
                                border-right: none;
                            }
                        }

                        /deep/ .el-table__cell {
                            padding: 5px 0;
                            background: #f2f5fc;
                        }
                    }

                    /deep/ .el-table__body {
                        img {
                            vertical-align: middle;
                            width: 52px;
                            height: 50px;
                        }
                    }
                }

                .pagination {
                    margin-top: 20px;
                    text-align: right;
                }
            }
        }
        .dialogBox{
            .details{
                .detailsItem{
                    padding-bottom: 20px;
                    h3{
                        font-weight: 700;
                        font-size: 16px;
                        color: #000;
                        margin-top: 0;
                        letter-spacing: 1px;
                        border-bottom: 1px solid #ddd;
                        padding-bottom: 15px;
                    }
                    .itemContent{
                        display: flex;
                        flex-wrap: wrap;
                        font-size: 15px;
                        padding: 0 30px;
                        .one-row{
                            width: 50%;
                            margin-bottom: 22px;
                            display: flex;
                            .label{
                                padding-right: 15px;
                                min-width: 95px;
                            }
                            .name{
                                color: #000;
                            }
                        }
                        .two-row{
                            width: 100%;
                            margin-bottom: 22px;
                            display: flex;
                            .label{
                                padding-right: 15px;
                                min-width: 95px;
                            }
                            .name{
                                color: #000;
                            }
                        }
                    }
                    .itemPictureContent{
                        display: flex;
                        flex-wrap: wrap;
                        font-size: 15px;
                        padding: 0 30px;
                        justify-content: space-between;
                        .one-row{
                            width: 30%;
                            margin-bottom: 22px;
                            img{
                                width: 100%;
                                height: 138px;
                                border: 1px solid #ddd;
                            }
                            .name{
                                text-align: center;
                                padding-top: 10px;
                                font-size: 14px;
                                display: flex;
                                .label{
                                    min-width: 80px;
                                }
                            }
                        }
                    }
                }
            }
            .audit{
                padding-bottom: 20px;
                h3{
                    font-weight: 700;
                    font-size: 16px;
                    color: #000;
                    margin-top: 0;
                    letter-spacing: 1px;
                    border-bottom: 1px solid #ddd;
                    padding-bottom: 15px;
                }
                .auditContent{
                    padding: 0 30px;
                }
                .cause{
                    display: flex;
                    margin-top: 20px;
                    .causeTitle{
                        min-width: 80px;
                        color: #3a8ee6;
                    }
                    .causeContent{
                        color: #000;
                    }
                }
                .auditEnter{
                    text-align: center;
                    padding-top: 20px;
                    button{
                        width: 120px;
                    }
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/userManager/userStaff.vue